import { Link } from "react-router-dom";
import type { ReactNode } from "react";

type Variant = "primary" | "outline" | "white" | "ghost";

const variantStyles: Record<Variant, string> = {
  primary: "bg-primary-500 text-background-50 hover:bg-primary-600",
  outline:
    "border-2 border-background-50/80 text-background-50 hover:bg-background-50 hover:text-foreground-950",
  white: "bg-background-50 text-primary-600 hover:bg-background-100",
  ghost: "bg-primary-100 text-primary-700 hover:bg-primary-200",
};

interface ButtonProps {
  variant?: Variant;
  to?: string;
  href?: string;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function Button({
  variant = "primary",
  to,
  href,
  children,
  className = "",
  onClick,
}: ButtonProps) {
  const base =
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3 text-sm font-semibold transition-all duration-200 cursor-pointer";
  const classes = `${base} ${variantStyles[variant]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes}>
        {children}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} className={classes}>
      {children}
    </button>
  );
}